var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.printMode
        ? [
            _c(
              "a-row",
              { attrs: { gutter: 24 } },
              [
                _c(
                  "a-col",
                  { attrs: { md: 24 } },
                  [
                    _c(
                      "a-card",
                      { style: _vm.cardStyle, attrs: { bordered: false } },
                      [
                        _c(
                          "div",
                          { staticClass: "table-page-search-wrapper" },
                          [
                            _c(
                              "a-form",
                              {
                                attrs: { layout: "inline" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.searchQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "a-row",
                                  { attrs: { gutter: 24 } },
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "门店",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("store-tenant-select", {
                                              attrs: { domain: "sale" },
                                              on: {
                                                change:
                                                  _vm.handleStoreTenantChange,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "单据编号",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                placeholder: "请输入单据编号",
                                              },
                                              model: {
                                                value: _vm.queryParam.number,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "number",
                                                    $$v
                                                  )
                                                },
                                                expression: "queryParam.number",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "单据日期",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("a-range-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                format: "YYYY-MM-DD",
                                                placeholder: [
                                                  "开始日期",
                                                  "结束日期",
                                                ],
                                              },
                                              on: { change: _vm.onDateChange },
                                              model: {
                                                value: _vm.queryParam.dateRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "dateRange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryParam.dateRange",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "table-page-search-submitButtons",
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.searchQuery },
                                            },
                                            [_vm._v("查询")]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              on: { click: _vm.searchReset },
                                            },
                                            [_vm._v("重置")]
                                          ),
                                          _vm.btnEnableList.indexOf("5") > -1
                                            ? _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: { icon: "printer" },
                                                  on: {
                                                    click: _vm.handlePrint,
                                                  },
                                                },
                                                [_vm._v("打印")]
                                              )
                                            : _vm._e(),
                                          _vm.btnEnableList.indexOf("3") > -1
                                            ? _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: { icon: "download" },
                                                  on: {
                                                    click: _vm.exportExcel,
                                                  },
                                                },
                                                [_vm._v("导出")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.toggleSearchStatus =
                                                    !_vm.toggleSearchStatus
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.toggleSearchStatus
                                                      ? "收起"
                                                      : "展开"
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("a-icon", {
                                                attrs: {
                                                  type: _vm.toggleSearchStatus
                                                    ? "up"
                                                    : "down",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.toggleSearchStatus
                                  ? [
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 24 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "商品",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "请输入条码、名称、助记码、规格、型号等信息",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryParam
                                                          .materialParam,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryParam,
                                                          "materialParam",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryParam.materialParam",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "客户",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "请选择客户",
                                                        dropdownMatchSelectWidth: false,
                                                        showSearch: "",
                                                        "allow-clear": "",
                                                        optionFilterProp:
                                                          "children",
                                                      },
                                                      on: {
                                                        search:
                                                          _vm.handleSearchOrgan,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.queryParam
                                                            .organId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.queryParam,
                                                            "organId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "queryParam.organId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.organList,
                                                      function (item, index) {
                                                        return _c(
                                                          "a-select-option",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              value: item.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.supplier
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "仓库",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请选择仓库",
                                                        "allow-clear": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.queryParam
                                                            .depotId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.queryParam,
                                                            "depotId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "queryParam.depotId",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.depotList,
                                                      function (item, index) {
                                                        return _c(
                                                          "a-select-option",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              value: item.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.depotName
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "类别",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c("a-tree-select", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      dropdownStyle: {
                                                        maxHeight: "200px",
                                                        overflow: "auto",
                                                      },
                                                      "allow-clear": "",
                                                      treeData:
                                                        _vm.categoryTree,
                                                      placeholder: "请选择类别",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryParam
                                                          .categoryId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryParam,
                                                          "categoryId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryParam.categoryId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        { attrs: { gutter: 24 } },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "关联单据",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c("a-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "请输入关联单据",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryParam
                                                          .linkNumber,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryParam,
                                                          "linkNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryParam.linkNumber",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "销售人员",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "请选择销售人员",
                                                        showSearch: "",
                                                        "allow-clear": "",
                                                        optionFilterProp:
                                                          "children",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.queryParam
                                                            .salesMan,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.queryParam,
                                                            "salesMan",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "queryParam.salesMan",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.personList,
                                                      function (item, index) {
                                                        return _c(
                                                          "a-select-option",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              value: item.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.name
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "操作员",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "请选择操作员",
                                                        showSearch: "",
                                                        "allow-clear": "",
                                                        optionFilterProp:
                                                          "children",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.queryParam
                                                            .creator,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.queryParam,
                                                            "creator",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "queryParam.creator",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.userList,
                                                      function (item, index) {
                                                        return _c(
                                                          "a-select-option",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              value: item.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.userName
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "section",
                          { ref: "print", attrs: { id: "reportPrint" } },
                          [
                            _c("a-table", {
                              ref: "table",
                              attrs: {
                                bordered: "",
                                size: "middle",
                                rowKey: "id",
                                columns: _vm.columns,
                                dataSource: _vm.dataSource,
                                pagination: false,
                                scroll: _vm.scroll,
                                loading: _vm.loading,
                              },
                              on: { change: _vm.handleTableChange },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "numberCustomRender",
                                    fn: function (text, record) {
                                      return _c("span", {}, [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleNumberClick(
                                                  record
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(record.number))]
                                        ),
                                      ])
                                    },
                                  },
                                ],
                                null,
                                false,
                                1168112724
                              ),
                            }),
                            _c(
                              "a-row",
                              {
                                staticStyle: {
                                  "margin-top": "8px",
                                  textAlign: "right",
                                },
                                attrs: { gutter: 24 },
                              },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 24, sm: 24 } },
                                  [
                                    _c("a-pagination", {
                                      attrs: {
                                        size: "small",
                                        "show-size-changer": "",
                                        "show-quick-jumper": "",
                                        current: _vm.ipagination.current,
                                        "page-size": _vm.ipagination.pageSize,
                                        "page-size-options":
                                          _vm.ipagination.pageSizeOptions,
                                        total: _vm.ipagination.total,
                                      },
                                      on: {
                                        change: _vm.paginationChange,
                                        showSizeChange:
                                          _vm.paginationShowSizeChange,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.printMode
        ? [
            _c(
              "div",
              {
                staticClass: "print-header",
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                  padding: "8px 16px",
                  background: "#fff",
                  "border-bottom": "1px solid #e8e8e8",
                  "margin-bottom": "12px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "16px", "font-weight": "500" },
                  },
                  [_vm._v(_vm._s(_vm.printTitle))]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { icon: "close" },
                    on: {
                      click: function ($event) {
                        _vm.printMode = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
            _c("ReportPrint", {
              attrs: {
                visible: true,
                tableData: _vm.printDataSource,
                queryParam: _vm.queryParam,
                billType: "SALE_PROFIT",
                billTypeName: "销售利润",
                buildData: _vm.buildPrintData,
                embedded: true,
              },
              on: {
                "designer-change": _vm.onDesignerChange,
                back: function ($event) {
                  _vm.printMode = false
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }